module.exports = __webpack_public_path__ + "img/bg.561cc18d.png";